export default __webpack_public_path__ + "static/ds-zeroheight-lapierre-colors-99dfd585bb3cbcb8e0e14390f61167f2.png";